var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "border border-textTertiary rounded p-4 w-full mb-4" },
    [
      _c(
        "div",
        { staticClass: "font-normal text-lg" },
        [_vm._t("title"), _vm._t("otherDeatils")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }